module.exports = __webpack_public_path__ + "static/media/hot_wlyyh.39b8cff8.png";